import { initServices } from './serviceConfig'

let _svc
let _that

export default {
  Init: async (that) => {
    _that = that

    _svc = await initServices()

    _svc.interceptors.response.use(
      response => response,
      error => {
        _that.ErrorMixin_HandleError(error)
      }
    )
  },
  GetGeoMapGRB: (straat, huisnummer, gemeente, width, height, mapType, capakey) => {
    try {
      return _svc.get('GeoMap/GRB', {
        params: {
          straat: straat,
          huisnummer: huisnummer,
          gemeente: gemeente,
          width: width,
          height: height,
          mapType: mapType,
          capakey: capakey
        }
      })
    } catch {
      return null
    }
  }
}
